import React, { useCallback, useRef } from 'react';

const Swiper = ({ onSwipe, tag = 'div', enableMouse = false, ...others }) => {
  const touch = useRef({ startX: 0, startY: 0 });
  const Tag = tag;

  const onTouchEvent = useCallback(
    (event) => {
      const x =
        event.changedTouches && event.changedTouches.length > 0
          ? event.changedTouches[0].screenX
          : event.screenX;
      const y =
        event.changedTouches && event.changedTouches.length > 0
          ? event.changedTouches[0].screenY
          : event.screenY;

      switch (event.type) {
        case 'touchstart':
        case 'mousedown':
          touch.current.startX = x;
          touch.current.startY = y;
          if (enableMouse) {
            document.body.addEventListener('mouseleave', onTouchEvent);
          }
          break;
        case 'touchend':
        case 'mouseup':
          if (enableMouse) {
            document.body.removeEventListener('mouseleave', onTouchEvent);
          }
          onSwipe({ deltaX: touch.current.startX - x, deltaY: touch.current.startY - y });
          break;
      }
    },
    [onSwipe, enableMouse]
  );

  const events = {
    onTouchStart: onTouchEvent,
    onTouchEnd: onTouchEvent,
  };

  if (enableMouse) {
    events.onMouseDown = onTouchEvent;
    events.onMouseUp = onTouchEvent;
  }

  return <Tag {...events} {...others} />;
};

export default Swiper;
